import './App.css';
import SHA256Visualizer from './SHA256Visualizer';

function App() {
  return (
    <div className="App">
      <SHA256Visualizer/>
    </div>
  );
}

export default App;
